import React, { memo, useContext, useEffect, useMemo, useRef, useState } from "react";
import AlertModal from "../shared/AlertModal";
import { Modal, ModalBody, ModalHeader } from "../modal/Modal";
import { format } from "date-fns";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Pagination from "../shared/Pagination";

import GLOBAL from "../../global";
import CONSTANT from "../../constants/Constant";
import AppContext from "../../contexts/AppContext";
import examService from "../../services/ExamService";
import routes from "../../constants/Routes";
import Assessment from "../../models/Assessment";
import FysicalScoreReportView from "../report/FysicalScoreReportView";
import ReportJsonViewer from "../report/ReportJsonViewer";
import Refresh from "../shared/Refresh";
import {
    getArrayFromObject,
    getBodyRegionsValueLabelObjectArray,
    getSportsTypeValueLabelObjectArray,
    isEmptyObject,
    isMobileDevice, isNSCSubdomain
} from "../../utils/Utils";
import MmhTable from "../shared/table/datatable/MmhTable";

import editBtn from "../../assets/img/myAssessmensList/editIcon.svg";
import startExerciseDisableBtn from "../../assets/img/myAssessmensList/startExerciseBtn.svg";
import viewReportBtn from "../../assets/img/myAssessmensList/eyeIcon.svg";
import SelectOption from "./SelectOption";
import MyAssessmentTooltip from "./MyAssessmentTooltip";
import MultipleSelectOption from "./MultipleSelectOption";
import BiometricMovementAndCautionQuestionContainer
    from "../shared/MovementModal/BiometricMovementAndCautionQuestionContainer";
import { toast } from "react-toastify";
import { _getInCompleteAssessmentType, getResumeGroupFromId } from "../dashboard/dashboardUtills";
import { saveIntake } from "../shared/intake-form/intake-form-service";
import useIntakeFrom from "../shared/intake-form/useIntakeFrom";
import useHandleExpiredAndUpcomingMeetingPopupMsg from "../../hooks/useHandleExpiredAndUpcomingMeetingPopupMsg";
import {
    resetEventData,
    setEventData
} from "../../features/askEmma/askEmmaSlice";
import { useDispatch } from "react-redux";
import Global from "../../global";
import PurchasedPackage from "../dashboard/PurchasedPackage";
import StartNewAssessment from "../dashboard/StartNewAssessment";
import { fetchPurchasePackageThunks } from "../../features/purchasePackage/purchasePackageThunks";
import { setSelectedTelemedicineInvitationId, setShowLoadingAtJoinNowBtn } from "../../features/dashboard/dashboardSlice";
import { setOpenBiometricMovementAndCautionQuestionContainer as setOpenBiometricRedux } from "../../features/dashboard/dashboardSlice";
import DashboardItem from "../dashboard/DashboardItem";
import NotificationInfo from "../dashboard/notification/NotificationInfo";
import ResumeBtn from "../dashboard/notification/ResumeBtn";
import { getNotificationData } from "../dashboard/notification/business/services";
import useDashboardBody from "../dashboard/useDashboardBody";

import styles from './MyAssessmentsDetail.module.scss';
import MobileAppSuggestionsModal from "../MobileAppSuggestions/MobileAppSuggestionsModal";
import MobileAppsLink from "../mobile-apps/AllAppsLink";
import PackageFooter from "../package/PackageFooter";
import AcademicCitationModal from "../shared/AcademicCitationModal";
import DeepDriveCard from "./DeepDriveCard";
import DeepDriveUploadModal from "./DeepDriveUploadModal";
import DeepDriveReportModal from "./DeepDriveReportModal";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import useDeviceCompatibility from "../../hooks/useDeviceCompatibility";

const MyAssessmentsDetail = memo((props) => {
    const { userInfo, setTelemedicineProperties, resetTelemedicineKeys, assessmentTypeForMyAssessmentPage, resetAssessmentTypeForMyAssessmentPage, setSelectedTabForEditAssessment } = useContext(AppContext);

    const { handleOpenIntakeForm, handleCloseIntakeForm, handleSetJoiningTelemedicine } = useIntakeFrom();
    const { getAssessmentAvailabilityStatus, handleOpenUpcomingOrExpiredPopupMessage } = useHandleExpiredAndUpcomingMeetingPopupMsg();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const { showCompletedAssessments, disableBiometricModal, isDashboard } = props
    const { EnableFysicalScore, IsPatientReportAvailable, IsSpinealignEnabled } = userInfo.Permissions;
    const [assessments, setAssessments] = useState([]);
    const [fysicalReportView, setFysicalReportView] = useState(false);
    const [fysicalRportUrl, setFysicalRportUrl] = useState('');
    const [selectedExam, setSelectedExam] = useState({});////TODO: need to remove
    const [showFollowUpAlert, setShowFollowUpAlert] = useState(false);
    const [showAssessmentModal, setShowAssessmentModal] = useState(false);
    const [FollowUpAlertMessage, setFollowUpAlertMessage] = useState('');
    const subscription = useRef(true);
    const [loadingAssessment, setLoadingAssessment] = useState(false);
    const [reloadMyRoms, setReloadMyRoms] = useState(false);
    const [redirectToAssessmentPage, setRedirectToAssessmentPage] = useState(false);
    const [redirectToMyExercises, setRedirectToMyExercises] = useState(false);
    const [filteredAssessments, setFilteredAssessments] = useState([]);
    const [reportFilterValue, setReportFilterValue] = useState(CONSTANT.FILTER_BY_REPORT.ALL.key);
    const [bodyRegions, setBodyRegions] = useState([]);
    const [sportsTypes, setSportsTypes] = useState([]);
    const pageRefressInterval = useRef()
    const myPageSize = useRef(CONSTANT.PAGE_SIZE.TEN.value);
    const myPageNumber = useRef(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
    const reportStatus = useRef(null);
    const sportsTypeList = useRef('');
    const bodyRegionList = useRef('');
    const isFollowUp = useRef(null);
    const isInCompleted = useRef(0);
    const invitationIdRef = useRef(null);
    const selectedExamRef = useRef(null);

    // eslint-disable-next-line
    // const [followUpFilterValue, setFollowUpFilterValue] = useState(CONSTANT.FOLLOW_UP.YES_OR_NO.key)
    const [totalRecord, setTotalRecord] = useState(0);
    const [loading, setLoading] = useState(true);
    const [reportStatusOption, setReportStatusOption] = useState(CONSTANT.FILTER_BY_REPORT.ALL.key);
    const [assessmentTypeOption, setAssessmentTypeOption] = useState(CONSTANT.ASSESSMENT_TYPE.ALL.key);
    const [testId, setTestId] = useState('');
    const [isNeedTableRefresh, setIsNeedTableRefresh] = useState(true);
    const [clickedRowId, setClickedRowId] = useState(-1);
    const [openBiometricMovementAndCautionQuestionContainer, setOpenBiometricMovementAndCautionQuestionContainer] = useState(false);
    console.log('MyAssessmentsDetail openBiometricMovementAndCautionQuestionContainer:', openBiometricMovementAndCautionQuestionContainer);
    const [biometricData, setBiometricData] = useState(null);
    const [allNotifications, setAllNotifications] = useState([]);
    const [isLoadingNotification, setIsLoadingNotification] = useState(true);
    const conformationAlertContentRef = useRef({});
    const [reportJsonData, setReportJsonData] = useState(null);
    const [reportJsonView, setReportJsonView] = useState(false);
    const [isLoadingReport, setIsLoadingReport] = useState(false);
    const [showMobileAppSuggestion, setShowMobileAppSuggestion] = useState(false);
    const [pendingActivityCellParams, setPendingActivityCellParams] = useState(null);
    const [deepDriveList, setDeepDriveList] = useState([]);
    const [isDeepDriveUploadModalOpen, setIsDeepDriveUploadModalOpen] = useState(false);
    const [selectedDeepDriveItem, setSelectedDeepDriveItem] = useState(null);
    const [showCitationModal, setShowCitationModal] = useState(false);
    const [selectedCitationTestId, setSelectedCitationTestId] = useState('');
    const [isDeepDriveReportModalOpen, setIsDeepDriveReportModalOpen] = useState(false);
    const [deepDriveReportData, setDeepDriveReportData] = useState(null);
    const [isLoadingDeepDriveReport, setIsLoadingDeepDriveReport] = useState(false);
    const [isLoadingDeepDriveList, setIsLoadingDeepDriveList] = useState(true);

    const { isAthleteEnabled: isAthleteEnabledFeature, isDeepDriveEnable, isDeepDriveEnabled, isSpinealignEnabled, isAcademicCitationEnabled, isHtmlReportEnable, isMyAssessmentsFooterEnable, isExamineticsEnabled, isIntakeTelemedicineFormEnable } = useTenantFeatures();
    const { isMobileAppSuggestionModalEnabled } = useDeviceCompatibility();
    const isAthleteEnabled = userInfo?.Permissions?.IsAthleteEnabled || isAthleteEnabledFeature;
    const isDeepDriveEnabledFinal = isDeepDriveEnable || isDeepDriveEnabled;

    const purchasePackageState = useSelector(state => state.purchasePackage);
    const emailAddress = (GLOBAL.USER_INFO && GLOBAL.USER_INFO["EmailAddress"]) || "";

    const fetchNotificationData = async () => {
        if (!isLoadingNotification) {
            setIsLoadingNotification(true);
            setAllNotifications([]);
        }
        const prepareData = await getNotificationData(emailAddress);
        setAllNotifications(prepareData);
        setIsLoadingNotification(false);
    }

    const toggleDeepDriveUploadModal = () => {
        setIsDeepDriveUploadModalOpen(!isDeepDriveUploadModalOpen);
    };

    const toggleDeepDriveReportModal = () => {
        setIsDeepDriveReportModalOpen(!isDeepDriveReportModalOpen);
    };

    const onStartDeepDrive = (item) => {
        setSelectedDeepDriveItem(item);
        toggleDeepDriveUploadModal();
    };

    const onViewDeepDriveReport = async (item) => {
        setSelectedDeepDriveItem(item);
        setDeepDriveReportData(null);

        const patientId = userInfo?.ContactId || GLOBAL.URL_PARAMS.PATIENT_ID || userInfo?.Id || 0;
        const payload = {
            sportsTypeId: item.SportsTypeId,
            patientId: patientId.toString(),
            tenant: GLOBAL.TENANT
        };

        setIsLoadingDeepDriveReport(true);
        toggleDeepDriveReportModal();

        const response = await examService.getDeepDriveReport(payload);
        const { data, success } = response;
        console.log('Raw API Response:', response);

        if (success && data) {
            let report = null;

            // 1. Check root level for content
            if (data.NarrativeResult || data.narrativeResult) {
                report = data;
                console.log('Found report at root level');
            }
            // 2. Check for Message property (most common)
            else if (data.Message || data.message) {
                report = data.Message || data.message;
                console.log('Found report in Message property');
            }
            // 3. Check for Data wrapper
            else if (data.Data || data.data) {
                const inner = data.Data || data.data;
                report = inner.Message || inner.message || inner;
                console.log('Found report in Data property');
            }

            // Fallback: If nothing found but we have data, use the raw data object
            if (!report && typeof data === 'object') {
                report = data;
                console.log('Fallback: using raw data object');
            }

            // String parsing fail-safe
            if (typeof report === 'string' && report.trim().startsWith('{')) {
                try {
                    report = JSON.parse(report);
                    console.log('Parsed string report to JSON object');
                } catch (e) {
                    console.error('JSON parsing failed:', e);
                }
            }

            console.log('Final Report Data State:', report);
            setDeepDriveReportData(report);
        } else {
            console.warn('API Response unsuccessful:', response);
            const errorMsg = (data?.ErrorMessages || data?.errorMessages || data?.Message || data?.message)?.[0] || 'Failed to load report';
            toast.error(errorMsg);
            toggleDeepDriveReportModal();
        }
        setIsLoadingDeepDriveReport(false);
    };

    const _getDeepDriveList = async () => {
        const patientId = userInfo?.ContactId || GLOBAL.URL_PARAMS.PATIENT_ID || userInfo?.Id || 0;
        if (!patientId) {
            console.warn('Deep Drive List: No valid patientId found, skipping fetch.');
            return;
        }
        const payload = {
            patientId: patientId,
            tenant: GLOBAL.TENANT
        };
        try {
            setIsLoadingDeepDriveList(true);
            const response = await examService.getDeepDriveList(payload);
            const { data, success } = response;
            if (success && data) {
                const result = data.Message || data.message || data;
                setDeepDriveList(result.DeepDriveListResult || []);
            }
        } catch (e) {
            console.error('Deep Drive List Fetch Error:', e);
        } finally {
            setIsLoadingDeepDriveList(false);
        }
    }

    useEffect(() => {
        if (isDeepDriveEnabledFinal) {
            _getDeepDriveList();
        }
    }, [isDeepDriveEnabledFinal]);

    const handleBotClose = async () => {
        await fetchNotificationData();
        setIsNeedTableRefresh(true);
    }

    const { handleNewUser, handleRemoteAssistance, notificationHandler, handleClickMore } = useDashboardBody(
        handleBotClose);

    useEffect(() => {
        if (isAthleteEnabled) {
            fetchNotificationData();
        }
    }, [isAthleteEnabled]);

    useEffect(() => {
        dispatch(setOpenBiometricRedux({
            openBiometricMovementAndCautionQuestionContainer: openBiometricMovementAndCautionQuestionContainer,
            testId: selectedExamRef.current?.TestId || (biometricData?.testId || ''),
            selectedBodyRegions: selectedExamRef.current?.BodyRegionList || biometricData?.bodyRegionList || []
        }));
    }, [openBiometricMovementAndCautionQuestionContainer]);

    // Listen for biometric modal open events and table refresh events from useHandlePayment
    useEffect(() => {
        const handleOpenBiometricEvent = (event) => {
            handleOpenBiometricModal(event.detail);
        };

        const handleRefreshTableEvent = () => {
            setIsNeedTableRefresh(true);
        };

        window.addEventListener('openBiometricModal', handleOpenBiometricEvent);
        window.addEventListener('refreshMyAssessmentsTable', handleRefreshTableEvent);

        return () => {
            window.removeEventListener('openBiometricModal', handleOpenBiometricEvent);
            window.removeEventListener('refreshMyAssessmentsTable', handleRefreshTableEvent);
        };
    }, []);

    const packages = purchasePackageState?.packages || [];
    const hasPackagesWithBalance = packages.some(pkg => pkg.balance > 0);
    const invitationListDoNotHaveTestIds = allNotifications.filter(notification => !notification.TestId) || [];
    const dashboardRootState = useSelector(state => state.dashboard);
    const isBiometricOpenInRedux = dashboardRootState?.biometric?.openBiometricMovementAndCautionQuestionContainer || false;

    useEffect(() => {
        if (!isBiometricOpenInRedux) {
            setOpenBiometricMovementAndCautionQuestionContainer(false);
        }
    }, [isBiometricOpenInRedux]);

    const showLoadingAtJoinNowBtn = dashboardRootState?.showLoadingAtJoinNowBtn || false;
    const selectedTelemedicineInvitationId = dashboardRootState?.selectedTelemedicineInvitationId || '';

    useEffect(() => {
        if (location.state?.refresh) {
            setIsNeedTableRefresh(true);
        }
    }, [location]);

    useEffect(() => {
        if (isNeedTableRefresh) {
            setLoading(true);
            // noinspection JSIgnoredPromiseFromCall
            if (assessmentTypeForMyAssessmentPage) {
                if (assessmentTypeForMyAssessmentPage?.isFollowUp) {
                    onChangeAssessmentTypeOption(CONSTANT.ASSESSMENT_TYPE.FOLLOW_UP.key);
                } else if (assessmentTypeForMyAssessmentPage?.isLastIncompletedAssessments) {
                    onChangeAssessmentTypeOption(CONSTANT.ASSESSMENT_TYPE.LAST_INCOMPLETE.key);
                }
            }
            _getMyAssessments().then(() => {
                resetAssessmentTypeForMyAssessmentPage();
                setIsNeedTableRefresh(false);
            })
        }
        // eslint-disable-next-line
    }, [isNeedTableRefresh]);

    useEffect(() => {
        dispatch(fetchPurchasePackageThunks());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // noinspection JSCheckFunctionSignatures
        setBodyRegions(getBodyRegionsValueLabelObjectArray());

        return () => {
            subscription.current = false;
            GLOBAL.ASSESSMENT = null;
            clearInterval(pageRefressInterval.current);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps,
    }, []);

    useEffect(() => {
        // noinspection JSCheckFunctionSignatures
        setSportsTypes(getSportsTypeValueLabelObjectArray());

        return () => {
            subscription.current = false;
            GLOBAL.ASSESSMENT = null;
            clearInterval(pageRefressInterval.current);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps,
    }, []);

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall

        if (reloadMyRoms) {
            _getMyAssessments().then();
            setReloadMyRoms(false);
        }
        // eslint-disable-next-line
    }, [reloadMyRoms, fetchPurchasePackageThunks]);

    const callMyAssessmentApi = async () => {
        const subscriptionType = parseInt(localStorage.getItem('SubscriptionType'), 10);
        let payload = {
            PageSize: myPageSize.current,
            PageNumber: myPageNumber.current,
            ReportStatus: reportStatus.current,
            BodyRegionList: bodyRegionList.current ? bodyRegionList.current.split`,`.map(x => +x) : [],
            SportsType: sportsTypeList.current ? sportsTypeList.current.split`,`.map(x => +x) : [],
            IsFollowUp: isFollowUp.current,
            IsInCompleted: isInCompleted.current,
            Completed: showCompletedAssessments,
            Search: `${testId}`,
            SubscriptionType: subscriptionType,
        };

        const response = await examService.getAssessments(payload);
        const { data, success, error } = response;

        if (subscription.current) {
            if (!success) {
                console.error(error);
                return [];
            }

            const tempData = data || '[]';
            setAssessments(tempData['MyRomList']);
            setTotalRecord(tempData['TotalRecords']);

            commonFilter({
                data: tempData['MyRomList'],
                reportStatus: reportFilterValue,
                bodyRegions: []
            });
        }
    }

    const _getMyAssessments = async () => {
        setLoading(true);
        await callMyAssessmentApi();
        clearInterval(pageRefressInterval.current);
        setLoading(false);
        setIsNeedTableRefresh(true);
    };

    const onClickActivityCell = (row, firstInCompletedGroup = {}, original = {}) => {
        if (isMobileAppSuggestionModalEnabled && isMobileDevice()) {
            // Store parameters and show mobile app suggestion modal
            setPendingActivityCellParams({ row, firstInCompletedGroup, original });
            setShowMobileAppSuggestion(true);
            return;
        }

        // Execute the existing flow
        executeActivityCellFlow(row, firstInCompletedGroup, original);
    }

    const executeActivityCellFlow = (row, firstInCompletedGroup = {}, original = {}) => {
        if (firstInCompletedGroup?.key === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key) {
            if (original?.InvitationType === CONSTANT.INVITATION_TYPE.Telemedicine) {
                onClickJoinNow(original, row)
            } else if (original?.InvitationType === CONSTANT.INVITATION_TYPE.Self || original?.InvitationType === undefined || original?.InvitationType === null) {
                openTakeBiometricMovementHandler(row)
            } else {
                // Default to self assessment if invitation type is unknown for biometric assessments
                openTakeBiometricMovementHandler(row)
            }
        } else if (original?.ReportUrl) {
            dispatch(setEventData({ eventName: 'patientPortal_posture-report', testId: original?.TestId }));
            onClickFysicalScoreReportCell(row)
        } else {
            onClickEditMeasurementCell(row, firstInCompletedGroup);
        }
    }

    const onClickEditMeasurementCell = (row, firstInCompletedGroup = {}) => {
        let keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
        if (!isEmptyObject(firstInCompletedGroup)) {
            keyOfFirstIncompleteGroup = firstInCompletedGroup?.key || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
            if (keyOfFirstIncompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key) keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key
        }
        setSelectedTabForEditAssessment(keyOfFirstIncompleteGroup);
        console.log({ keyOfFirstIncompleteGroup })
        GLOBAL.ASSESSMENT = null;
        const { original } = row;
        setSelectedExam(original);
        setRedirectToAssessmentPage(true);
        invitationIdRef.current = original.InvitationId;
    };

    const onClickCitation = (testId) => {
        setSelectedCitationTestId(testId);
        setShowCitationModal(true);
    };

    const onHideCitationModal = () => {
        setShowCitationModal(false);
        setSelectedCitationTestId('');
    };

    const onConfirmFollowUpAlert = async () => {
        setShowFollowUpAlert(false);
        setShowAssessmentModal(true);
        setLoadingAssessment(true);
        setFollowUpAlertMessage('');
        GLOBAL.ASSESSMENT = null;

        const payload = { TestId: selectedExam.TestId };
        const response = await examService.followUp(payload);
        const { success, data } = response;

        setLoadingAssessment(false);
        setReloadMyRoms(true);

        if (!success) {
            console.error('Error in follow up test creation');
            setShowAssessmentModal(false);
            return;
        }

        if (data) {
            const examData = data || '{}';
            selectedExam.TestId = examData.TestId;
            GLOBAL.ASSESSMENT = new Assessment({ TestId: examData.TestId });
        }
    };

    const onCancelFollowUpAlert = () => {
        setShowFollowUpAlert(false);
        setFollowUpAlertMessage('');
    };

    const onContinueWithWeb = () => {
        setShowMobileAppSuggestion(false);
        if (pendingActivityCellParams) {
            const { row, firstInCompletedGroup, original } = pendingActivityCellParams;
            executeActivityCellFlow(row, firstInCompletedGroup, original);
            setPendingActivityCellParams(null);
        }
    };

    const onCancelMobileAppSuggestion = () => {
        setShowMobileAppSuggestion(false);
        setPendingActivityCellParams(null);
    };

    const toggleShowAssessmentModal = () => {
        setShowAssessmentModal(false);
    };

    const onClickStartMovement = () => {
        setShowAssessmentModal(false);
    };

    const onClickUpdateAssessment = async () => {
        setRedirectToAssessmentPage(true);
    }

    const onClickFysicalScoreReportCell = async (row) => {
        if (!IsPatientReportAvailable) return;
        const { original } = row;
        const testId = original['TestId'];
        const url = original['ReportUrl'];

        // Use HTML-based JSON report viewer if enabled
        if (isHtmlReportEnable) {
            setIsLoadingReport(true);
            setReportJsonView(true);

            const jsonData = await _getAssessmentReportJson(testId);

            if (jsonData) {
                setReportJsonData(jsonData);
                setIsLoadingReport(false);
            } else {
                console.error('No JSON report data available for TestId:', testId);
                setIsLoadingReport(false);
                setReportJsonView(false);

                // Fallback to old PDF viewer
                if (isMobileDevice()) {
                    window.open(url, '_blank');
                } else {
                    setFysicalRportUrl(url);
                    toggleFysicalReportModal();
                }
            }
        } else {
            // Use PDF viewer when HTML report is disabled
            if (isMobileDevice()) {
                window.open(url, '_blank');
            } else {
                setFysicalRportUrl(url);
                toggleFysicalReportModal();
            }
        }
    };

    const openTakeBiometricMovementHandler = (row) => {
        selectedExamRef.current = row.original;
        setOpenBiometricMovementAndCautionQuestionContainer(true);
    }

    const handleOpenBiometricModal = (data) => {
        if (data) {
            // Data passed from StartNewAssessment component
            setBiometricData(data);
            selectedExamRef.current = {
                TestId: data.testId,
                BodyRegionList: data.bodyRegionList
            };
        }
        setOpenBiometricMovementAndCautionQuestionContainer(true);
    }

    const onClickTrackMovement = (row) => () => {
        GLOBAL.ASSESSMENT = null;
        const { original } = row;
        setSelectedExam(original);
        setRedirectToMyExercises(true);
    }

    const onClickJoinNow = (original, cell) => {
        const assessmentAvailabilityStatus = getAssessmentAvailabilityStatus(original?.MeetingStartDate, original?.MeetingEndDate);
        if (assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.KEY || assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY) {
            handleOpenUpcomingOrExpiredPopupMessage(assessmentAvailabilityStatus);
            return;
        }

        const isIntakeSigned = (GLOBAL.USER_INFO && GLOBAL.USER_INFO['IsIntakeSigned']) || '';
        const rowId = original?.TestId || cell?.index;
        selectedExamRef.current = {
            id: rowId,
            invitationId: cell?.original?.InvitationId,
            bodyRegionList: cell?.original?.BodyRegionList,
            TestId: cell?.original?.TestId
        };

        if (!isIntakeSigned && isIntakeTelemedicineFormEnable) {
            let bodyRegionList = cell?.original?.BodyRegionList || '';
            let invitationTypeName = cell?.original?.ReferTypeName || '';

            handleOpenIntakeForm({
                bodyRegionList: bodyRegionList || [],
                invitationTypeName: invitationTypeName || '',
                showSubmitBtn: true,
                onClickSubmitIntakeForm: onClickSubmitIntakeForm
            })
        } else {
            handleJoinNow(rowId, original?.InvitationId, original?.BodyRegionList);
        }
    }

    const onClickSubmitIntakeForm = async (values) => {
        handleSetJoiningTelemedicine(true);
        let selectedExam = selectedExamRef.current;
        if (!selectedExam || !selectedExam?.id || !selectedExam?.bodyRegionList || !selectedExam?.TestId) return;

        GLOBAL.ASSESSMENT = new Assessment({ TestId: selectedExam?.TestId });
        setClickedRowId(selectedExam?.id);
        const response = await saveIntake(values);
        const { data, success, error } = response;
        if (!success) {
            toast.error(error || 'Failed to save intake form');
            onCloseTelemedicine();
            return;
        }
        handleJoinNow(selectedExam?.id, selectedExam?.invitationId, selectedExam?.bodyRegionList);
    }

    const handleJoinNow = (id, invitationId, bodyRegionList) => {
        handleCloseIntakeForm();
        setClickedRowId(id);
        setTelemedicineProperties(invitationId, bodyRegionList, null, onCloseTelemedicine);
        dispatch(setSelectedTelemedicineInvitationId(invitationId));
        dispatch(setShowLoadingAtJoinNowBtn(true));
    }

    const onCloseTelemedicine = () => {
        handleSetJoiningTelemedicine(false);
        handleCloseIntakeForm();
        resetTelemedicineKeys();
        setClickedRowId(-1);
        dispatch(setSelectedTelemedicineInvitationId(null));
        dispatch(setShowLoadingAtJoinNowBtn(false));
        GLOBAL.ASSESSMENT = null;
    }

    const toggleFysicalReportModal = () => {
        if (fysicalReportView) {
            dispatch(resetEventData());
        }
        setFysicalReportView(!fysicalReportView);
    };

    const _getAssessmentReportJson = async (testId) => {
        try {
            const payload = { TestId: testId };
            const response = await examService.getPatientReportData(payload);
            const { data, success, error } = response;

            if (!success) {
                console.error('API Error:', error);
                return null;
            }

            if (data && typeof data === 'object') {
                if (data.Message) {
                    return data;
                } else if (data.PatientInfo || data.Narratives || data.ReportHeading) {
                    return { Message: data };
                }
            }
            return null;
        } catch (error) {
            console.error('Error fetching report JSON:', error);
            return null;
        }
    };

    const toggleReportJsonModal = () => {
        if (reportJsonView) {
            dispatch(resetEventData());
            setReportJsonData(null);
            setIsLoadingReport(false);
        }
        setReportJsonView(!reportJsonView);
    };

    const columns = useMemo(() => {
        const baseColumns = [
            ...(isAthleteEnabled
                ? [{
                    Header: 'Sport',
                    HeaderSecLine: '',
                    Cell: (cellProps) => {
                        const { original } = cellProps.row;
                        return `${original['SportsType']}`;
                    }
                }]
                : []
            ),
            {
                Header: 'Body Region',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return original?.IsExempt === true
                        ? 'Exempt'
                        : `${original['BodyRegionName']}`;
                }
            },
            {
                Header: 'Status',
                style: 'white-space-pre',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    let firstInCompletedGroup = getResumeGroupFromId(original?.ResumeGroupId);
                    let isReportAvailable = !!original?.ReportUrl;
                    let assessmentAvailabilityStatus = getAssessmentAvailabilityStatus(original?.MeetingStartDate, original?.MeetingEndDate);

                    return (
                        <>
                            {!isReportAvailable ? (
                                <>
                                    {(
                                        isEmptyObject(firstInCompletedGroup) && !isReportAvailable && original?.IsReportReady)
                                        ? <span className="badge badge-warning font-medium font-size-sm" style={{ color: 'var(--my-exercises-list-badge-warning-text-color) !important' }}>In Review</span>

                                        : <div>
                                            <button
                                                className="btn pointer button-row btn-border"
                                                id={`edit-${original['TestId']}`}
                                                onClick={() => onClickActivityCell(cellProps.row, firstInCompletedGroup, original)}
                                                disabled={
                                                    // (clickedRowId === cellProps?.row?.id)
                                                    // Removed the InClinic + Biometric restriction to allow biometric assessments to open
                                                    ((original['InvitationType'] === CONSTANT.INVITATION_TYPE.InClinic) && (firstInCompletedGroup?.key === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key))
                                                }
                                            >
                                                <div className="d-flex justify-content-center align-items-center">
                                                    {clickedRowId === cellProps?.row?.id
                                                        ? <><i className="fa fa-spinner fa-spin margin-right-0-75rem"></i></>
                                                        : <> <i className={"far fa-edit margin-right-0-75rem"}></i> </>
                                                    }
                                                    {
                                                        !isEmptyObject(firstInCompletedGroup)
                                                            ? ((original['InvitationType'] === CONSTANT.INVITATION_TYPE.Telemedicine) && (firstInCompletedGroup?.key === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key))
                                                                ? (
                                                                    (assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.KEY) && (<>{CONSTANT.ASSESSMENT_AVAILABILITY.UPCOMING.MESSAGE}</>)) ||
                                                                ((assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY) && (<>{CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.MESSAGE}</>)) ||
                                                                ((assessmentAvailabilityStatus === CONSTANT.ASSESSMENT_AVAILABILITY.AVAILABLE.KEY) && (<>{CONSTANT.ASSESSMENT_AVAILABILITY.AVAILABLE.MESSAGES.JOIN_NOW}</>)
                                                                )
                                                                : `Resume ${original?.ResumeGroupName || ""}` : ""
                                                    }

                                                    {(isEmptyObject(firstInCompletedGroup) && !isReportAvailable && original?.IsReportReady)
                                                        ?
                                                        <span className="badge badge-warning font-medium font-size-sm">In Review</span>
                                                        : ""
                                                    }
                                                    {/*Not need exactly just for safety*/}
                                                    {(isEmptyObject(firstInCompletedGroup) && !isReportAvailable && !original?.IsReportReady) ? "Edit" : ""}
                                                </div>
                                                <MyAssessmentTooltip text="Update Information" target={`edit-${original['TestId']}`} />
                                            </button>
                                        </div>
                                    }

                                </>
                            ) : ""}

                            {
                                isReportAvailable &&
                                <>
                                    <button
                                        className={`btn button-row btn-border d-flex justify-content-center align-items-center ${IsPatientReportAvailable ? '' : 'pointer-none opacity-0_4'}`}
                                        onClick={() => onClickActivityCell(cellProps.row, firstInCompletedGroup, original)}
                                    >
                                        View Report
                                    </button>
                                    {(isSpinealignEnabled && isAcademicCitationEnabled) && (
                                        <button
                                            className={`btn button-row btn-border d-flex justify-content-center align-items-center ${IsPatientReportAvailable ? '' : 'pointer-none opacity-0_4'}`}
                                            onClick={() => onClickCitation(original?.TestId)}
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Citation
                                        </button>
                                    )}
                                </>
                            }
                        </>
                    )
                }
            },
            {
                Header: 'Test ID',
                style: 'white-space-pre',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    let isReportPDFAvailable = !!original?.ReportUrl;
                    let firstInCompletedGroup = getResumeGroupFromId(original?.ResumeGroupId);
                    const isExempt = original?.IsExempt === true;
                    const isBiometricIncomplete = firstInCompletedGroup?.key === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key;
                    const shouldShowTestIdAction = isExempt || isBiometricIncomplete || isReportPDFAvailable || original?.IsReportReady;

                    return (
                        <div className="text-center">
                            <p className="mb-0">{original?.IsFollowUp ? " FOLLOW-UP: " : ""}{original['TestId']}</p>
                            {original?.BaseTestId ? <p className="m-0">Initial: {original['BaseTestId']}</p> : null}

                            {shouldShowTestIdAction
                                ? (
                                    <div>
                                        <button
                                            className="button button-dashboard rounded-100px border-0 padding-x-8-px padding-y-5-px"
                                            onClick={() => onClickEditMeasurementCell(cellProps.row)}
                                        >
                                            {(!isExempt && isBiometricIncomplete)
                                                ? (
                                                    <><i className="fa-regular fa-pen-to-square"></i> Edit</>
                                                ) : null
                                            }
                                            {(isExempt || isReportPDFAvailable || original?.IsReportReady)
                                                ? (
                                                    <><i className="fa-regular fa-eye"></i> View</>
                                                ) : null
                                            }
                                        </button>
                                    </div>
                                )
                                : null
                            }
                        </div>
                    )
                }
            },
            {
                Header: 'Order',
                HeaderSecLine: 'Date',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return format(new Date(original['SubmissionDate']) || new Date(), CONSTANT.DATE_FORMAT.MMM_DD_YYYY);
                }
            },
            ...(!isAthleteEnabled
                ? [{
                    Header: 'Assessment',
                    HeaderSecLine: 'Type',
                    Cell: (cellProps) => {
                        const { original } = cellProps.row;
                        return `${original['InvitationTypeTxt']}`;
                    }
                }]
                : []
            ),
            // {
            //     id: 'home-exercise-column',
            //     Header: 'Home',
            //     HeaderSecLine: 'Exercises',
            //     style: 'w-100 text-center kt-align-center',
            //     Cell: (cellProps) => {
            //         const {original} = cellProps.row;
            //
            //         return (
            //             <>
            //                 {original['TotalHomeExercise'] === 0
            //                     ? (
            //                         <span className="badge badge-warning font-medium font-size-sm color-black">Not Available</span>
            //                     )
            //                     : (
            //
            //                         <button
            //                             className="btn pointer button-row bg-color-ice-blue-4"
            //                             id={`home_exercise-${original['TestId']}`}
            //                             onClick={onClickTrackMovement(cellProps.row)}
            //                         >
            //             <span className="d-flex justify-content-center align-items-center color-primary-dark-1">
            //                 <img className="mr-3" src={startExerciseDisableBtn} alt="Home Exercise" /> Start
            //             </span>
            //                             <MyAssessmentTooltip text="Start Home Exercise" target={`home_exercise-${original['TestId']}`} />
            //                         </button>
            //
            //                     )
            //                 }
            //             </>
            //         );
            //     }
            // },
        ];

        // ✅ Final filtered return
        let result = baseColumns;
        if (IsSpinealignEnabled) {
            result = result.filter(col => col.id !== 'home-exercise-column');
        }

        if (isExamineticsEnabled && isDashboard) {
            result = result.filter(col => {
                const header = col.Header;
                // Keep only 'Test ID', 'Status', and 'Order' (Order Date)
                return header === 'Test ID' || header === 'Status' || header === 'Order';
            });
        }

        return result;

    }, [IsSpinealignEnabled, onClickEditMeasurementCell, getAssessmentAvailabilityStatus, clickedRowId, IsPatientReportAvailable, onClickActivityCell, isDashboard, isExamineticsEnabled]);


    const onChangeReportStatusOption = (value) => {
        setReportStatusOption(value);

        if (value === CONSTANT.FILTER_BY_REPORT.IN_PROGRESS.key) {
            reportStatus.current = 2;
        }
        if (value === CONSTANT.FILTER_BY_REPORT.COMPLETED.key) {
            reportStatus.current = 1;
        }
        if (value === CONSTANT.FILTER_BY_REPORT.ALL.key) {
            reportStatus.current = null;
        }

        myPageNumber.current = CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value;
        myPageSize.current = CONSTANT.PAGE_SIZE.TEN.value;
        setIsNeedTableRefresh(true);
        setReportFilterValue(value);
        commonFilter({ data: assessments, reportStatus: value });
    }

    const onChangeSelectBodyRegion = (values) => {
        const keys = values.map(item => item.value);

        bodyRegionList.current = '';
        keys.map((key) => {
            if (bodyRegionList.current.length > 0) {
                bodyRegionList.current = bodyRegionList.current + ',' + key;
            } else {
                bodyRegionList.current = key + '';
            }
        })

        myPageNumber.current = CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value;
        myPageSize.current = CONSTANT.PAGE_SIZE.TEN.value;
        setIsNeedTableRefresh(true);
    }

    const onChangeSelectSportsType = (values) => {
        const keys = values.map(item => item.value);

        sportsTypeList.current = '';
        keys.map((key) => {
            if (sportsTypeList.current.length > 0) {
                sportsTypeList.current = sportsTypeList.current + ',' + key;
            } else {
                sportsTypeList.current = key + '';
            }
        })

        myPageNumber.current = CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value;
        myPageSize.current = CONSTANT.PAGE_SIZE.TEN.value;
        setIsNeedTableRefresh(true);
    }

    const onChangeAssessmentTypeOption = (value) => {
        setAssessmentTypeOption(value);

        if (value === CONSTANT.ASSESSMENT_TYPE.FOLLOW_UP.key) {
            isFollowUp.current = true;
            isInCompleted.current = 0;
        }
        if (value === CONSTANT.ASSESSMENT_TYPE.LAST_INCOMPLETE.key) {
            isFollowUp.current = null;
            isInCompleted.current = 1;
        }
        if (value === CONSTANT.ASSESSMENT_TYPE.ALL.key) {
            isFollowUp.current = null;
            isInCompleted.current = 0;
        }

        myPageNumber.current = CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value;
        myPageSize.current = CONSTANT.PAGE_SIZE.TEN.value;

        setIsNeedTableRefresh(true);
        // setFollowUpFilterValue(value);
        commonFilter({ data: assessments, followUp: value });
    }

    const onKeyUpTestId = (e) => {
        e.preventDefault();
        setTestId(e.target.value);
        myPageNumber.current = CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value;
        myPageSize.current = CONSTANT.PAGE_SIZE.TEN.value;
        setReloadMyRoms(true);
    }

    const handlePageSize = (event) => {
        myPageSize.current = event.target.value;
        myPageNumber.current = CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value;
        setIsNeedTableRefresh(true);
    }

    const handleRefresh = () => {
        setReloadMyRoms(true);
    }

    const commonFilter = (
        {
            data,
        }) => {
        //as already api filtering the data we do not need to filter those data again
        setFilteredAssessments(data);
    }

    const onClickRedirectToPricingPage = () => {
        history.push(routes.packages);
    };

    return (
        <>
            {redirectToAssessmentPage && (
                <>
                    <Redirect to={`${routes.editAssessment}/${selectedExam.TestId}?groupId=${selectedExam?.ResumeGroupId}`} />
                </>

            )}
            {redirectToMyExercises && (
                <Redirect to={`${routes.myExercises}/${selectedExam.TestId}`} />
            )}

            {isAthleteEnabled && hasPackagesWithBalance &&
                (
                    <StartNewAssessment
                        packages={packages}
                        callbackFetchNotificationData={handleBotClose}
                        setOpenBiometricMovementAndCautionQuestionContainer={handleOpenBiometricModal}
                        refreshPackages={() => dispatch(fetchPurchasePackageThunks())}
                    />
                )
            }

            {(invitationListDoNotHaveTestIds.length > 0) ? (
                <div className="dashboard-item-content-text" style={{ width: "100%" }}>
                    <div style={{ padding: "2rem 4rem" }}>
                        <h1 className="heading-large">New Assessment Invitation</h1>
                        <div className="flex-1">
                            {invitationListDoNotHaveTestIds.map((item, index) => (
                                <div className="dashboard-item" key={index}>
                                    <div className="">
                                        <div className="d-flex justify-content-between margin-bottom-2-rem">
                                            <div className="d-flex justify-content-center align-content-center flex-wrap">
                                                <div className="">
                                                    <NotificationInfo
                                                        notificationData={{
                                                            MeetingDate: item?.MeetingDate,
                                                            BodyRegionList: item?.BodyRegionList,
                                                            InvitationTypeName: item?.InvitationTypeName,
                                                            InvitationTypeId: item?.InvitationTypeId,
                                                            SportsType: item?.SportsType,
                                                        }}
                                                    >
                                                        <ResumeBtn
                                                            InvitationTypeId={item?.InvitationTypeId}
                                                            firstIncompleteGroupName={getResumeGroupFromId(item?.ResumeGroupId)}
                                                            isLoading={!showLoadingAtJoinNowBtn && selectedTelemedicineInvitationId === item.InvitationId}
                                                            notificationHandler={notificationHandler}
                                                            conformationAlertContentRef={conformationAlertContentRef}
                                                            notificationData={item}
                                                            IsLastIncomplete={item?.IsLastIncomplete}
                                                            MeetingStart={item?.MeetingStart}
                                                            MeetingEnd={item?.MeetingEnd}
                                                        />
                                                    </NotificationInfo>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="dashboard-item-spepbar-container" style={{height: "1rem"}}></div>*/}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )
                :
                null
            }

            <div className="font-wight-500 my-assessment bg-color-white w-100-percent">
                <div className="w-100-percent margin-bottom-3-rem">
                    {
                        (!packages?.length && isAthleteEnabled && !loading && !allNotifications?.length) && <div className="d-flex flex-direction-column gap-5 justify-content-center align-items-center mb-4">
                            <p style={{ color: '#4C4C4C', fontSize: '1.3rem' }}>No assessment is linked to your account. Explore our sports programs and pricing to get started.</p>

                            <button
                                type="button"
                                className="btn btn-primary w-118px"
                                onClick={onClickRedirectToPricingPage}
                            >
                                Pricing
                            </button>
                        </div>
                    }

                    {!isSpinealignEnabled &&
                        <div className={styles['my-assessments-detail__filter-list']}>
                            <div className='d-flex-center-center gap-20px'>
                                <div className='filter-item'>
                                    <label htmlFor="example-text-input">Report</label>

                                    <SelectOption
                                        onChange={onChangeReportStatusOption}
                                        value={reportStatusOption}
                                        values={getArrayFromObject(CONSTANT.FILTER_BY_REPORT)}
                                    />
                                </div>
                                {
                                    (!isAthleteEnabled && !isExamineticsEnabled) && <div className='filter-item'>
                                        <label htmlFor="example-text-input">Assessment Type</label>
                                        <SelectOption
                                            onChange={onChangeAssessmentTypeOption}
                                            value={assessmentTypeOption}
                                            // values={getArrayFromObject(CONSTANT.FOLLOW_UP)}
                                            values={getArrayFromObject(CONSTANT.ASSESSMENT_TYPE)}
                                        />
                                    </div>
                                }
                                {
                                    (EnableFysicalScore && !isAthleteEnabled && !isExamineticsEnabled) && (
                                        <div className='filter-item'>
                                            <label htmlFor="example-text-input">Body Region</label>

                                            <MultipleSelectOption
                                                placeholder="Body Region"
                                                options={bodyRegions}
                                                onChange={onChangeSelectBodyRegion}
                                            />
                                        </div>
                                    )
                                }
                                {/*{isAthleteEnabled && (*/}
                                {/*    <div className={styles['my-assessments-detail__filter-list--label--item']}>*/}
                                {/*        <label htmlFor="example-text-input"*/}
                                {/*               className={`${styles['align-self-center']} ${styles['my-assessments-detail__filter-list--label--small']}`}>Sports Type</label>*/}

                                {/*        <div className={styles['my-assessments-detail__filter-width-height']}>*/}
                                {/*            <MultipleSelectOption*/}
                                {/*                placeholder="Sports Type"*/}
                                {/*                options={sportsTypes}*/}
                                {/*                onChange={onChangeSelectSportsType}*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*)}*/}

                                {
                                    !isExamineticsEnabled && (
                                        <div className='filter-item'>
                                            <label htmlFor="example-text-input">Test ID</label>
                                            <input
                                                className='filter_width_height select-option'
                                                placeholder="Enter Test ID"
                                                onChange={e => setTestId(e.target.value)}
                                                onKeyUp={onKeyUpTestId}
                                            />
                                        </div>
                                    )
                                }
                            </div>

                            <Refresh refreshFunction={handleRefresh} />
                        </div>
                    }

                    <MmhTable columns={columns} data={filteredAssessments} loading={loading} />

                    <div className="mt-3 table-pagination">
                        <div className="table-pagination__page-number">
                            <Pagination
                                currentPage={myPageNumber.current}
                                totalPages={Math.ceil(totalRecord / myPageSize.current)}
                                onPageChange={(page) => {
                                    myPageNumber.current = page;
                                    setIsNeedTableRefresh(true);
                                }}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                            />
                        </div>
                        <div className="table-pagination__quantity-in-a-page">
                            <span
                                className="table-pagination__info">Showing {((myPageNumber.current * myPageSize.current) - myPageSize.current) + 1} to {(myPageNumber.current * myPageSize.current)} of {totalRecord} entries</span>
                            <select
                                className="form-control-sm color-primary"
                                onChange={handlePageSize}
                                value={myPageSize.current}>
                                {getArrayFromObject(CONSTANT.PAGE_SIZE)?.map((item, index) => {
                                    return (
                                        <option key={index} value={item.value}>
                                            {item.name}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            {isDeepDriveEnabledFinal && (
                isLoadingDeepDriveList ? (
                    <div className="d-flex flex-direction-column justify-content-center align-items-center p-5" style={{ minHeight: '150px' }}>
                        <div className="kt-spinner kt-spinner--lg kt-spinner--info"></div>
                        <p className="mt-3">Loading...</p>
                    </div>
                ) : (
                    deepDriveList && deepDriveList?.map((item, index) => (
                        <DeepDriveCard
                            key={item.Id || index}
                            item={item}
                            onStart={onStartDeepDrive}
                            onViewReport={onViewDeepDriveReport}
                        />
                    ))
                )
            )}

            {
                isMyAssessmentsFooterEnable && <div className="dashboard-item-content-text" style={{ width: "100%", margin: "2rem 0" }}>
                    <div style={{ padding: "2rem 1rem" }}>
                        <div className="flex-1">
                            <PackageFooter />
                        </div>
                    </div>
                </div>
            }

            {isHtmlReportEnable ? (
                reportJsonView && (
                    <ReportJsonViewer
                        open={reportJsonView}
                        reportData={reportJsonData}
                        isLoading={isLoadingReport}
                        toggleModal={toggleReportJsonModal}
                    />
                )
            ) : (
                fysicalReportView && (
                    <FysicalScoreReportView
                        open={fysicalReportView}
                        url={fysicalRportUrl}
                        toggleFysicalReportModal={toggleFysicalReportModal}
                    >
                    </FysicalScoreReportView>
                )
            )}

            {showFollowUpAlert && (
                <AlertModal
                    show={showFollowUpAlert}
                    showCancel
                    cancelBtnCssClass="btn btn-sm btn-success"
                    confirmBtnCssClass="btn btn-sm btn-danger"
                    cancelBtnText="Yes, create it!"
                    confirmBtnText="No, don't create it!"
                    title='Are you sure?' warning
                    onCancel={onConfirmFollowUpAlert}
                    onConfirm={onCancelFollowUpAlert}
                    closeOnClickOutside={false}>
                    {FollowUpAlertMessage}
                </AlertModal>
            )}
            {showAssessmentModal && (
                <Modal isOpen={showAssessmentModal} className="modal-md">
                    <ModalHeader toggle={toggleShowAssessmentModal}>
                        Confirmation of assessment changes
                    </ModalHeader>
                    <ModalBody>
                        {loadingAssessment && (
                            <div className="h-300">
                                <div className="kt-spinner kt-spinner--lg kt-spinner--info kt-mb-20" />
                            </div>
                        )}
                        {!loadingAssessment && (
                            <>
                                <p className="kt-margin-b-20">
                                    Do you want to change Activity of Daily Living or Medical History or Chief Complaints? Please press button yes otherwise start movement.
                                </p>
                                <button type="button"
                                    className="btn btn-primary kt-margin-r-10"
                                    onClick={onClickUpdateAssessment}>
                                    Yes, Update Assessment
                                </button>
                                <button type="button"
                                    className="btn btn-primary"
                                    onClick={onClickStartMovement}>
                                    Start/Review Movement
                                </button>
                            </>
                        )}
                    </ModalBody>
                </Modal>
            )}

            {showMobileAppSuggestion && (
                <AlertModal
                    show={showMobileAppSuggestion}
                    confirmBtnCssClass="btn btn-sm btn-secondary"
                    // confirmBtnText="Cancel"
                    title='Mobile App Available'
                    // onConfirm={onCancelMobileAppSuggestion}
                    closeOnClickOutside={false}
                    showConfirm={false}
                >
                    <MobileAppSuggestionsModal />
                </AlertModal>
            )}

            {!disableBiometricModal && openBiometricMovementAndCautionQuestionContainer &&
                <BiometricMovementAndCautionQuestionContainer
                    data={{
                        testId: selectedExamRef.current?.TestId || (biometricData?.testId || ''),
                        selectedBodyRegions: { bodyRegionList: selectedExamRef.current?.BodyRegionList || biometricData?.bodyRegionList || [] },
                        openBiometricMovementAndCautionQuestionContainer,
                    }}
                    setOpenBiometricMovementAndCautionQuestionContainer={setOpenBiometricMovementAndCautionQuestionContainer}
                />
            }

            {isDeepDriveUploadModalOpen && (
                <DeepDriveUploadModal
                    isOpen={isDeepDriveUploadModalOpen}
                    toggle={toggleDeepDriveUploadModal}
                    deepDriveId={selectedDeepDriveItem?.Id}
                    deepDriveTitle={selectedDeepDriveItem?.Title}
                    onSubmit={() => {
                        _getDeepDriveList();
                        toggleDeepDriveUploadModal();
                    }}
                />
            )}

            {isDeepDriveReportModalOpen && (
                <DeepDriveReportModal
                    isOpen={isDeepDriveReportModalOpen}
                    toggle={toggleDeepDriveReportModal}
                    reportData={deepDriveReportData}
                    isLoading={isLoadingDeepDriveReport}
                    title={selectedDeepDriveItem?.Title}
                />
            )}
        </>
    )
});

export default MyAssessmentsDetail;
